var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetFriendly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.841,
    height: 25.562,
    viewBox: "0 0 30.841 25.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(-1146.656 -2018.249)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 2.669,
    cy: 3.776,
    rx: 2.669,
    ry: 3.776,
    transform: "translate(1154.887 2019.727) rotate(-5.608)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 3.776,
    cy: 2.669,
    rx: 3.776,
    ry: 2.669,
    transform: "matrix(0.146, -0.989, 0.989, 0.146, 1163.081, 2026.57)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 3.478,
    cy: 3.027,
    rx: 3.478,
    ry: 3.027,
    transform: "translate(1167.895 2031.809) rotate(-62.384)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 3.027,
    cy: 3.478,
    rx: 3.027,
    ry: 3.478,
    transform: "translate(1147.668 2028.449) rotate(-27.616)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M612.494,1286.11s2.642-.231,3.89,3a9.756,9.756,0,0,0,2.305,3.29c1.491,1.278,2.679,2.77,1.157,5.631s-5.783,1.583-5.783,1.583a6.58,6.58,0,0,0-3.866.122,4.235,4.235,0,0,1-5.053-1.948,4.848,4.848,0,0,1,1.218-5.418,11,11,0,0,0,2.1-3.247A4.375,4.375,0,0,1,612.494,1286.11Z",
    transform: "translate(549.53 743.04)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M643.806,1305.82a8.837,8.837,0,0,0,2.446,2.993",
    transform: "translate(521.062 728.663)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetFriendly);
export default __webpack_public_path__ + "static/media/pet-friendly.c606a6981df6a8a8b81e2ea3d774bf78.svg";
export { ForwardRef as ReactComponent };